$(document).on('turbolinks:load', function() {
  $('.ui.right.dropdown.item.account-dropdown').dropdown()
  $('.ui.toast').toast({
    displayTime: 5000,
    closeIcon: true,
    showProgress: 'bottom',
    progressUp: true
  })
})